import { useRef } from 'react';
import { TldrawEditor, defaultShapeUtils } from 'tldraw';
import { useMultiplayerSync } from '@/hooks/useMultiplayerSync';
import { useMeetingStore } from '@/stores/meeting';
import { DocProps } from '@/types/api';
import { usePdfManager } from '@/hooks/usePdfManager';
import { getAssetUrlsByImport } from '@tldraw/assets/imports.vite';

const assetUrls = getAssetUrlsByImport();

interface PdfWorkerProps {
  onDone: (id: string) => void;
  currentExportDoc: DocProps;
}

export function PdfWorker({ onDone, currentExportDoc }: PdfWorkerProps) {
  const isProcessed = useRef(false);

  const meeting = useMeetingStore((state) => state.meeting);
  const meetingUid = meeting?.uuid;
  const roomId = `tldraw-meeting-pdf-${meeting?.uuid}-${meeting?.author_uuid}-${currentExportDoc?.id}`;
  const syncResult = useMultiplayerSync(roomId);
  const pdfContainerRef = useRef<HTMLDivElement>(null);

  const { loadPdf, exportPdf } = usePdfManager(meetingUid, pdfContainerRef);

  return (
    <div
      style={{
        position: 'absolute',
        opacity: 0,
        pointerEvents: 'none',
        zIndex: -9999,
        width: 1,
        height: 1,
        overflow: 'hidden'
      }}
      id={`worker-${currentExportDoc.id}`}
      ref={pdfContainerRef}
    >
      {syncResult.status === 'synced-remote' && (
        <TldrawEditor
          assetUrls={assetUrls}
          store={syncResult.store}
          shapeUtils={defaultShapeUtils}
          onMount={(editor) => {
            if (isProcessed.current) return;
            isProcessed.current = true;

            const runExport = async () => {
              try {
                const path = currentExportDoc.path.startsWith('/')
                  ? currentExportDoc.path.slice(1)
                  : currentExportDoc.path;
                const completeFilename = `${location.origin}/${path}`;
                const fileName = currentExportDoc.path.split('/').pop();
                const dataPdf = await loadPdf(
                  `${currentExportDoc.id}-drawing-${fileName}`,
                  completeFilename
                );
                if (dataPdf) await exportPdf(editor, dataPdf);
              } catch (e) {
                console.error(`Ошибка воркера для ${currentExportDoc.id}:`, e);
              } finally {
                onDone(currentExportDoc.id);
              }
            };

            runExport();
          }}
        />
      )}
    </div>
  );
}
export default PdfWorker;
